// utils/websocket.js
import store from '@/vuex/store'; // 引入 Vuex store
import Cookies from 'js-cookie';
class WebSocketUtil {
  constructor(url) {
    this.url = url; // WebSocket 服务器地址
    this.socket = null; // WebSocket 实例
    this.listeners = {}; // 事件监听器
    this.reconnectAttempts = 0; // 重连次数
    this.maxReconnectAttempts = 5; // 最大重连次数
    this.reconnectInterval = 3000; // 重连间隔时间（毫秒）
    this.heartbeatInterval = 1000; // 心跳包间隔时间（毫秒）
    this.heartbeatTimer = null; // 心跳包定时器
    this.isManualClose = false; // 是否手动关闭连接
  }

  // 连接 WebSocket
  connect(userId,token) {
    if (this.socket) {
      console.warn('WebSocket is already connected.');
      return;
    }

    this.isManualClose = false; // 重置手动关闭标志
	if(token){
		this.socket = new WebSocket(this.url + '/' + userId + '/' + token);
	}else{
		this.socket = new WebSocket(this.url + '/' + userId);
	}
    // console.log(this.url,userId,token)
    this.socket.onopen = () => {
      console.log('WebSocket connection opened.');
      this.emit('open');
      this.startHeartbeat(); // 启动心跳包
      // 连接稳定 10 秒后才重置重连计数器
      // 如果 10 秒内又断开，计数器继续累加，到 5 次后停止重连
      this.resetTimer = setTimeout(() => {
        this.reconnectAttempts = 0;
      }, 10000);
    };

    this.socket.onmessage = (event) => {
      //console.log('WebSocket 接收消息:', event.data);
      //this.emit('message', event.data);
	  const data = JSON.parse(event.data)
	  this.onMessage(event.data);
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket 连接关闭, code:', event.code, 'reason:', event.reason);
      this.emit('close');
      this.stopHeartbeat(); // 停止心跳包
      // 清除重置计数器的定时器（连接没稳定住，不重置）
      if (this.resetTimer) {
        clearTimeout(this.resetTimer);
        this.resetTimer = null;
      }
      this.socket = null;

      if (this.isManualClose) return;

      this.handleReconnect(userId,token); // 非手动关闭时尝试重连
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
      this.emit('error', error);
      // 不在这里重连，统一由 onclose 处理，避免重复触发
    };
  }

  // 发送消息
  send(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(message);
      //console.log('消息发送成功:', message);
    } else {
      console.warn('WebSocket 未连接.');
    }
  }

  // 关闭 WebSocket
  close() {
    this.isManualClose = true; // 标记为手动关闭
    if (this.socket) {
      this.socket.close();
      console.log('WebSocket 关闭成功.');
    } else {
      console.warn('WebSocket 未连接.');
    }
  }

  // 处理重连
  handleReconnect(userId,token) {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`);
      setTimeout(() => {
        this.connect(userId,token);
      }, this.reconnectInterval);
    } else {
      console.error('达到重新连接最大次数.');
    }
  }

  // 启动心跳包
  startHeartbeat() {
    this.heartbeatTimer = setInterval(() => {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.send(JSON.stringify({ type: 'heartbeat' })); // 发送心跳包
        //console.log('发送心跳.');
      }
    }, this.heartbeatInterval);
  }

  // 停止心跳包
  stopHeartbeat() {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
      console.log('心跳停止.');
    }
  }

  // 注册事件监听
  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
  }

  // 移除事件监听
  off(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(listener => listener !== callback);
    }
  }

  // 触发事件
  emit(event, ...args) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(listener => listener(...args));
    }
  }
}

export default WebSocketUtil;


// WEBPACK FOOTER //
// ./src/utils/WebSocket.js